import React from 'react';
import { useAvatar } from '../../../hooks/useAvatar';
import urls from '../../../utils/urls';
import ScaledImage from '../../v2BaseComponents/ScaledImage';

export type OrganizationInviteLogoOwnProps = {
    organizationId: string;
    organizationClientInviteId: string;
};

export type OrganizationInviteLogoProps = OrganizationInviteLogoOwnProps;

const OrganizationInviteLogo: React.FC<OrganizationInviteLogoProps> = ({
    organizationClientInviteId,
    organizationId,
}) => {
    const { avatar } = useAvatar({
        avatarAPIUrl: urls.api.organizations.clientInvitations.invitationOrganizationLogo(
            organizationId,
            organizationClientInviteId,
        ),
    });

    if (!avatar?.base64) return null;

    return (
        <ScaledImage
            uri={avatar.base64}
            restrict="width"
            containerStyle={{ width: 200, backgroundColor: 'transparent' }}
            alt="Organization Logo"
        />
    );
};

export default React.memo(OrganizationInviteLogo);
